import React, {useRef, useContext, useState} from 'react';
import {Button, TextField} from '@material-ui/core';
import {LoadingContext, LoadingProvider} from '../../contexts';
import {Loader} from '../Loader';
import TurnstileCaptcha from '../Captcha/TurnstileCaptcha';

const TextInput = ({label, name, type, value, autoComplete, onChange}) => {
  const {isLoading} = useContext(LoadingContext);
  return (
    <TextField
      {...{
        disabled: isLoading,
        id: name,
        label: label || name,
        name,
        onChange,
        required: true,
        type: type || 'text',
        value,
        autoComplete: autoComplete,
      }}
    />
  );
};

const SubmitButton = ({text = 'submit', disabled = true}) => {
  const {isLoading} = useContext(LoadingContext);
  return (
    <Button disabled={disabled} type="submit" color="primary" className="mt-2">
      {isLoading ? <Loader /> : text}
    </Button>
  );
};

export const CustomForm = ({button, className, fields, onSubmit, withRecaptcha}) => {
  const {setIsLoading} = useContext(LoadingContext);
  const [loadingTurnstile, setLoadingTurnstile] = useState(true); // Track Turnstile loading state
  const turnstuleRef = useRef();
  const ref = useRef();

  const submit = event => {
    event.preventDefault();
    if (turnstuleRef.current?.getResponse()) {
      const formData = Object.fromEntries(new FormData(event.target));
      return onSubmit(event, formData);
    }

    setIsLoading(true);
    turnstuleRef.current?.reset();
  };

  return (
    <form {...{className, onSubmit: submit, ref}}>
      {fields.map((field, key) => (
        <TextInput key={key} {...field} />
      ))}
      {withRecaptcha && (
        <div className="text-center mt-5">
          <TurnstileCaptcha
            turnstuleRef={turnstuleRef}
            setLoadingTurnstile={setLoadingTurnstile}
          />
        </div>
      )}
      <SubmitButton disabled={loadingTurnstile} {...button} />
    </form>
  );
};

export const Form = props => (
  <LoadingProvider>
    <CustomForm {...props} />
  </LoadingProvider>
);
